var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelatedLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link",
    clipPath: "url(#clip0_15984_6887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.0001 7.27928C5.21483 7.56634 5.48878 7.80387 5.80337 7.97575C6.11797 8.14763 6.46585 8.24984 6.82342 8.27545C7.181 8.30105 7.53989 8.24946 7.87577 8.12417C8.21165 7.99888 8.51666 7.80281 8.7701 7.54928L10.2701 6.04928C10.7255 5.57777 10.9775 4.94627 10.9718 4.29078C10.9661 3.63528 10.7032 3.00825 10.2396 2.54473C9.77613 2.08121 9.14909 1.81829 8.4936 1.81259C7.83811 1.8069 7.20661 2.05888 6.7351 2.51428L5.8751 3.36928M7.0001 6.27928C6.78537 5.99222 6.51142 5.75469 6.19682 5.58281C5.88223 5.41093 5.53435 5.30872 5.17677 5.28311C4.8192 5.2575 4.46031 5.3091 4.12443 5.43439C3.78855 5.55968 3.48354 5.75574 3.2301 6.00928L1.7301 7.50928C1.2747 7.98079 1.02272 8.61229 1.02841 9.26778C1.03411 9.92328 1.29703 10.5503 1.76055 11.0138C2.22407 11.4773 2.8511 11.7403 3.5066 11.746C4.16209 11.7517 4.79359 11.4997 5.2651 11.0443L6.1201 10.1893",
    stroke: "#444CE7",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15984_6887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.777344)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatedLink);
export default __webpack_public_path__ + "static/media/relatedLink.fffdc22ae05d1c942eb9d648db868c4c.svg";
export { ForwardRef as ReactComponent };